<script>
import resources from './resources'

export default {
  name: 'gadget-professional',

  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Bem-vindo(a) ao Medibook!", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          select-dates
          statistics-agendas
          next-patient
          active-agenda
</template>



// WEBPACK FOOTER //
// src/app/employee/dashboard/gadget/index.vue